import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const BasketballIcon = observer('BasketballIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='basketballMask'
                width='14'
                height='14'
                x='1'
                y='1'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#142448'
                    d='M1.333 7.417a6.8 6.8 0 0 1 .35-1.609 5.9 5.9 0 0 1 .734-1.425q.582.6.975 1.392A5.3 5.3 0 0 1 3.9 7.417zm10.7 0A5.35 5.35 0 0 1 13.517 4.4q.465.65.733 1.417.267.765.35 1.6zM2.417 11.8a5.6 5.6 0 0 1-.734-1.408 6.8 6.8 0 0 1-.35-1.609H3.9a5.2 5.2 0 0 1-.508 1.634 5.5 5.5 0 0 1-.975 1.383m11.1 0q-.6-.6-.984-1.383a5.4 5.4 0 0 1-.5-1.634H14.6a7 7 0 0 1-.35 1.6 5.5 5.5 0 0 1-.733 1.417M5.25 7.417A6.4 6.4 0 0 0 4.6 5.2a7 7 0 0 0-1.35-1.833 6.5 6.5 0 0 1 1.825-1.284 7 7 0 0 1 2.208-.616v5.95zm3.4 0v-5.95a7 7 0 0 1 2.208.616q1.026.483 1.825 1.284a6.4 6.4 0 0 0-1.358 1.825 6.6 6.6 0 0 0-.642 2.225zm-1.367 7.316a6.8 6.8 0 0 1-2.216-.625 6.6 6.6 0 0 1-1.817-1.291A6.4 6.4 0 0 0 4.608 11a6.5 6.5 0 0 0 .642-2.217h2.033zm1.367 0v-5.95h2.033q.134 1.2.642 2.225a6.4 6.4 0 0 0 1.358 1.825 6.5 6.5 0 0 1-1.825 1.284 7 7 0 0 1-2.208.616'
                />
            </mask>
            <g mask='url(#basketballMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
